import { collection, doc, onSnapshot, query, where} from "firebase/firestore";
import React, { useEffect, useState }  from "react";
import { db } from "../firebase";
import useAuth from '../Auth/useAuth';


const ParticularStudentResult = () => {
  const {user}=useAuth();
  const [studentProfile,setStudentProfile] = useState([]);

  const [resultStudent, setResultStudent] = useState([]);

  useEffect(()=>{
    const q = query(collection(db, "admissionStudentList"), where("emailId", "==",user.email));
     const unsubscribe = onSnapshot(q, (querySnapshot) => {
    let studentArray = [];
    querySnapshot.forEach((doc) => {
    studentArray.push( {id:doc.id,...doc.data()});
  });
  setStudentProfile(studentArray);
   });
  
   },[user.email])
     
useEffect(()=>{
if(studentProfile.length>0){
  const q = query(collection(db, "resultStudent"), where("studentIdNumber", "==", studentProfile[0]?.studentIdNumber.toString()));
   onSnapshot(q, (querySnapshot) => {
    const resultArr = [];
    querySnapshot.forEach((doc) => {
        resultArr.push({id:doc.id,...doc.data()});
    });
    setResultStudent(resultArr);
  });}

},[studentProfile[0]?.studentIdNumber])


     const showGradeTerm1 = (marks)=> {
       
       if (marks < 33) {
         return "Fail"
        } else if (marks >= 33 && marks < 40) { 
        return "D"
      } else if (marks >= 40 && marks < 50) {
        return "C2"
      }else if (marks >= 50 && marks < 60) {
        return "C1"
      }else if (marks >= 60 && marks < 70) {
        return "B2"
      }else if (marks >= 70 && marks < 80) {
        return "B1"
      }else if (marks >= 80 && marks < 90) {
        return "A2"
      }else if (marks >= 90 && marks < 100) {
        return "A1"
      } else {
        return "N/A"
      }
    }
  
   
    const showTotalGradeTerm1 = (marks)=> {
      if (marks < 198) {
        return "Fail"
      } else if (marks >= 198 && marks < 240) {
        return "D"
      } else if (marks >= 240 && marks < 300) {
        return "C2"
      }else if (marks >= 300 && marks < 360) {
        return "C1"
      }else if (marks >= 360 && marks < 420) {
        return "B2"
      }else if (marks >= 420 && marks < 480) {
        return "B1"
      }else if (marks >= 480 && marks < 540) {
        return "A2"
      }else if (marks >= 540 && marks < 600) {
        return "A1"
      } else {
        return "N/A"
      }
    }

 

  return (
    <div className="p-5  min-h-screen">
    {resultStudent?.map((item, index) => (
 <div className="w-full text-gray-700" key={index}>
  <div className="mb-2 text-center w-full">
<div className='mb-1'> 
<span className="block font-bold lg:text-center mb-1 lg:mb-0 pr-4 sm:text-xl lg:text-2xl underline underline-offset-8 ">
  REPORT CARD FOR THE CLASS-<span>{item.studiedRoman}</span>/<span>{item.classSection}</span>
  </span>
</div>
</div>
      <div className="block sm:hidden">
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-md text-right col-span-3">Student Name</h2>
                <h2 className="font-bold text-md col-span-1">:</h2>
                <h2 className="font-bold text-md text-left col-span-3">{studentProfile[0]?.fullName}</h2>
              </div>
      <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-md text-right col-span-3">Student Code</h2>
                <h2 className="font-bold text-md col-span-1">:</h2>
                <h2 className="font-bold text-md text-left col-span-3">{studentProfile[0]?.studentIdNumber}</h2>
              </div>
              <div className="grid grid-cols-7 justify-evenly">
                <h2 className="font-bold text-md text-right col-span-3">Academic Session</h2>
                <h2 className="font-bold text-md col-span-1">:</h2>
                <h2 className="font-bold text-md text-left col-span-3">{item.academicSession}</h2>
              </div>
      </div>   
      <div className="sm:grid sm:grid-cols-3 hidden pl-5 pr-5 ">
          <div className="text-black-500 text-lg font-bold text-center ">
            <div className="w-full max-w-sm">
              <div className="lg:flex  lg:items-center mb-6 ">
                <div className="lg:w-2/5">
                  <label
                    className="block text-gray-500 font-bold lg:text-center mb-1 lg:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student's Name
                  </label>
                </div>
                <div className="lg:w-2/5 text-left">
                {item.studentName}
                </div>
              </div>
            </div>

          </div>
          <div className="  text-black-500 text-lg font-bold text-center   ">
            <div className="w-full max-w-sm">
              <div className="lg:flex lg:items-center mb-6 ">
                <div className="lg:w-1/2 ">
                  <label
                    className="block text-gray-500 font-bold lg:text-center mb-1 lg:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Academic Session
                  </label>
                </div>
                <div className="lg:w-2/5 text-left">
                {item.academicSession}
                </div>
              </div>
            </div>

          </div>
          <div className=" text-black-500 text-lg font-bold text-center ">
            <div className="w-full max-w-sm">
              <div className="lg:flex lg:items-center mb-6">
                <div className="lg:w-2/5">
                  <label
                    className="block text-gray-500 font-bold lg:text-center mb-1 lg:mb-0 pr-4"
                    htmlFor="inline-full-name"
                  >
                    Student ID
                  </label>
                </div>
                <div className="lg:w-2/5 text-left">
                  <div>{item.studentIdNumber}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

       <div className="mt-5">
        <div className="overflow-x-auto shadow-md sm:rounded-lg">
          <table className="min-w-full border text-center">
          <thead className="border-b ">
          <tr><td colSpan={7} >  <div className="text-xl text-white uppercase py-3  font-semibold bg-[#6c707b] ">
            Term-I (100 Marks)
          </div></td></tr>
              <tr className="bg-gray-100">
                <th className="py-3">Subject Name</th>
                <th className="py-3">Per Test (10)</th>
                <th className="py-3">Note Book (05)</th>
                <th className="py-3">Subject Enrichment (05)</th>
                <th className="py-3">Half Yearly Exam (80)</th>
                <th className="py-3">Marks Obtained (100)</th>
                <th className="py-3">Grade</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  English
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.perTestExamEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.noteBookEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.subjectEnrichmentEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.halfYearlyExamEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainEnglishTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1((parseFloat(item.totalObtainEnglishTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Hindi
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainHindiTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainHindiTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Sanskrit
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainSanskritTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainSanskritTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Maths
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainMathsTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainMathsTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Science
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainScienceTerm1)/100 )*100)}
                </td>
              
              </tr>
              <tr className="border-b">
                <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Social Science
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {item.perTestExamSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.noteBookSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                 {item.subjectEnrichmentSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.halfYearlyExamSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.totalObtainSocialScienceTerm1}
                </td>
                <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                {showGradeTerm1((parseFloat(item.totalObtainSocialScienceTerm1)/100 )*100)}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="min-w-full border text-center">
            <tbody>
                  <tr>
                  <td  className="py-2 px-3 text-sm font-medium text-gray-900 "> 
                  Total Marks : {item.totalMarksTerm1}
                </td>
                <td  className="py-2 px-1 text-sm font-medium text-gray-900 ">
                  Obtained Marks : {item.totalObtainedMarksTerm1}
                </td>
                <td  className="py-2 px-2 text-sm font-medium text-gray-900 ">
                   PercentageTerm1 : {item.percentageTerm1}
                </td>
                <td  className="py-2 px-2 text-sm font-medium text-gray-900 ">
                 Grade :{showTotalGradeTerm1(item.totalObtainedMarksTerm1)}

                </td>
                  </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
    ))}
     <div className="mt-4 ">
    {/* <button
    onClick={downloadResult}
      className="w-32 py-1.3 bg-blue-400  text-2xl text-white font-semibold"
    >
      Download
    </button> */}
  </div>
      </div>
  )
}

export default ParticularStudentResult